import { API_URL } from "@/config";
import axios from "axios";

export default {
  namespaced: true,

  actions: {
    async getMany(_, { filters = {}, pageNumber = 1, perPage = 20 }) {
      let query = {
        ...filters,
        page: pageNumber,
        perPage: perPage,
      };

      const response = await axios.get(`${API_URL}/scannedCardEntries`, { params: query });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, scannedCardEntryId) {
      const response = await axios.get(`${API_URL}/scannedCardEntries/${scannedCardEntryId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, scannedCardEntryData) {
      const response = await axios.post(`${API_URL}/scannedCardEntries`, scannedCardEntryData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};
